import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TextField from '@mui/material/TextField';

const formatNumberWithCommas = (value) => {
  if (!value) return '';
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const NumberTextField = (props) => {
  const {
    hintValue,
    isReadOnly = false,
    name,
    formik,
    disableValidation = false,
    value,
    onFocusValue,
    ...otherProps
  } = props;

  const [displayValue, setDisplayValue] = useState('');

  useEffect(() => {
    setDisplayValue(formatNumberWithCommas(formik ? formik.values[name] : value));
  }, [formik, name, value]);

  const handleOnChange = (event) => {
    const rawValue = event.target.value.replace(/,/g, ''); // Remove commas

    if (!/^\d*$/.test(rawValue)) {
      return; // Ignore non-numeric input
    }

    setDisplayValue(formatNumberWithCommas(rawValue)); // Format and set display value

    if (formik) {
      formik.setFieldValue(name, rawValue); // Pass raw number to Formik

      if (rawValue) {
        formik.setFieldError(name, undefined); // Clear the error
      }
    }
  };

  const handleOnBlur = (e) => {
    if (onFocusValue) {
      let lastValue = e.target.value;
      onFocusValue(lastValue);
    }

    // Update Formik's touched state if formik is provided
    if (formik) {
      formik.setFieldTouched(name, true);
    }
  };

  const hasError =
    !disableValidation &&
    formik &&
    formik.touched[name] &&
    Boolean(formik.errors[name]);

  const errorText = hasError ? formik.errors[name] : undefined;

  return (
    <TextField
      {...otherProps}
      name={name}
      fullWidth
      variant="outlined"
      value={displayValue}
      placeholder={formatNumberWithCommas(hintValue)}
      error={hasError}
      helperText={errorText}
      onChange={handleOnChange}
      onBlur={handleOnBlur}
      InputProps={{
        readOnly: isReadOnly,
      }}
      InputLabelProps={{
        shrink: hintValue ? true : undefined,
      }}
    />
  );
};

NumberTextField.propTypes = {
  formik: PropTypes.shape({
    touched: PropTypes.object,
    errors: PropTypes.object,
    values: PropTypes.object,
    setFieldValue: PropTypes.func.isRequired,
    setFieldTouched: PropTypes.func.isRequired,
  }),
  hintValue: PropTypes.any,
  isReadOnly: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  disableValidation: PropTypes.bool,
};

export default NumberTextField;
